<template>
  <b-card no-body class="mt-6">
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-colorblue"
      :data="projects"
    >
      <el-table-column label="Sr no" min-width="100px" prop="srno" sortable>
        <b-form-group>
          <b-form-checkbox
            v-model="selected"
            name="some-radios"
            value="B"
          ></b-form-checkbox>
        </b-form-group>
      </el-table-column>

      <el-table-column
        label="Group Name"
        min-width="200px"
        prop="groupName"
        sortable
      >
        <template v-slot="{ row }">
          <b-media-body>
            <span class="font-medium name mb-0 text-sm">{{ row.title }}</span>
          </b-media-body>
        </template>
      </el-table-column>

      <el-table-column
        label="Total Phone"
        prop="totalContact"
        min-width="140px"
        sortable
      >
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import projects from "./projects";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      projects,
      currentPage: 1,
    };
  },
};
</script>
